import React from 'react';
import { useTranslation } from 'react-i18next';

import setActiveTopMenuDropdownOperation from 'editor/src/store/app/operation/setActiveTopMenuDropdownOperation';
import isTopMenuDropdownVisible from 'editor/src/store/app/selector/isTopMenuDropdownVisible';
import { TopMenuDropdown } from 'editor/src/store/app/types';
import isImageMaskAllowed from 'editor/src/store/editor/selector/isImageMaskAllowed';
import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import setSidebarActiveTabOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabOperation';
import isSidebarTabActive from 'editor/src/store/editorModules/sidebar/selector/isSidebarTabActive';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import IconImageMask from 'editor/src/component/Icon/IconImageMask';
import { MenuItemProps } from 'editor/src/component/Menu/type';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

type Props = Pick<MenuItemProps, 'mode' | 'close' | 'isMobile'>;

function ButtonImageMask({ mode, close, isMobile }: Props) {
  const { t } = useTranslation();
  const isActive = useSelector((state) =>
    isMobile
      ? isSidebarTabActive(state, TAB_NAMES.IMAGE_MASK)
      : isTopMenuDropdownVisible(state, TopMenuDropdown.ImageMask),
  );
  const dispatch = useDispatch();
  const hasShapes = useSelector(isImageMaskAllowed);

  const handleClick = () => {
    if (isMobile) {
      dispatch(isActive ? setSidebarActiveTabOperation(-1) : setSidebarActiveTabByNameOperation(TAB_NAMES.IMAGE_MASK));
    } else {
      dispatch(setActiveTopMenuDropdownOperation(TopMenuDropdown.ImageMask));
      close?.();
    }
  };

  return (
    <MenuButton
      Icon={IconImageMask}
      on={isActive}
      mode={mode}
      handleClick={handleClick}
      label={t(hasShapes ? 'editor-image-shape' : 'editor-image-soft-edge')}
      className="cy-button-image-mask"
    />
  );
}

export default React.memo(ButtonImageMask);
